export enum OrganizationServiceType {
  ACCOUNTING = 'ACCOUNTING',
}
